import { render, staticRenderFns } from "./SessionViewUserInfoCard.vue?vue&type=template&id=087786c2&"
import script from "./SessionViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./SessionViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports